/*
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2024-10-17 15:48:04
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-10-22 14:58:53
 * @FilePath: \cei-saas-platform\src\store\modules\recordsstatus.js
 * @Description: 获取企业未读推送记录状态 在台账页面显示小红点
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { getRecordsstatus } from '@/api/contract'

const state = {
	recordsStatus: 1 // 0 未读 1 已读
}
const mutations = {
	SET_RECORDSSTATUS: (state, data) => {
		state.recordsStatus = data
	}
}
const actions = {
	// 获取未读推送记录状态
	getRecordsStatus({ commit }) {
		return new Promise((resolve, reject) => {
			getRecordsstatus().then((response) => {
				if (response.status == 200000) {
					// console.log('xxxxxxxx', response.data)
					commit('SET_RECORDSSTATUS', response.data.status)
					return resolve(response.data)
				} else {
					return reject(response.message)
				}
			})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
